module.exports = __webpack_public_path__ + "img/bag_yushou.51f0c23e.jpg";